import { useState } from 'react';
import { bool, func, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@fff-web/fff-ui-shared';
import { cancelUserSubscription } from '../../../../modules/growth';
import * as styles from './CancelSubscriptionConfirmation.module.scss';

const refillCopy =
  'Canceling a subscription will not affect any orders currently processing. All future deliveries will be canceled.';
const refillHeader = 'Cancel Your Subscription?';
const lastRefillProductCopy =
  'Canceling a subscription will not affect any orders currently processing. All future deliveries will be canceled. You won’t be able to access any membership perks once your subscription ends.';
const defaultHeader = 'Are You Sure You Want To Cancel Your Subscription?';
const defaultCopy =
  'Are you sure you want to cancel your subscription? Cancelling a subscription will not cancel any order that is currently processing. All future deliveries of this subscription will be canceled.';

const CancelSubscriptionConfirmation = ({
  subscriptionUuid,
  cadenceType,
  onNeverMind,
  onSubscriptionCancelled,
  cancelUserSubscription,
  isLastRefillProduct,
  isRefillOnly,
}) => {
  const [canceling, setCanceling] = useState(false);
  const isRefillProduct = cadenceType === 'NINETY_DAYS';
  const refillProductCopy =
    isLastRefillProduct && isRefillOnly ? lastRefillProductCopy : refillCopy;
  const header = isRefillProduct ? refillHeader : defaultHeader;
  const copy = isRefillProduct ? refillProductCopy : defaultCopy;

  const cancelSubscription = () => {
    setCanceling(true);
    cancelUserSubscription(subscriptionUuid)
      .then(() => {
        onSubscriptionCancelled();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setCanceling(false));
  };

  return (
    <div className={styles.container} data-testid="cancel-subscription-confirmation-container">
      <h1 className={styles.title}>{header}</h1>
      <p className={styles.info} data-testid="info">
        {copy}
      </p>
      <div className={styles.buttonsContainer} data-testid="buttons-container">
        <Button disabled={canceling} onClick={onNeverMind}>
          Never Mind
        </Button>
        <Button disabled={canceling} onClick={cancelSubscription} variation="primary-outline">
          Confirm Cancellation
        </Button>
      </div>
    </div>
  );
};

CancelSubscriptionConfirmation.propTypes = {
  subscriptionUuid: string.isRequired,
  cadenceType: string.isRequired,
  onNeverMind: func.isRequired,
  onSubscriptionCancelled: func.isRequired,
  isMobile: bool.isRequired,
  cancelUserSubscription: func.isRequired,
  isRefillOnly: bool.isRequired,
  isLastRefillProduct: bool,
};

const mapStateToProps = (state) => ({
  isMobile: state.view.isMobile,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cancelUserSubscription,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CancelSubscriptionConfirmation);
